<div class="dashboard-content roles-directory-page" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">

    <!-- Standard page heading: title left, search + primary action right -->
    <div class="page-heading">
      <h3>{{ 'roles-page.directory-title' | translate }}</h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [(ngModel)]="searchTerm"
            [placeholder]="'roles-page.search-placeholder' | translate" autocapitalize="off"
            style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="searchTerm" (click)="searchTerm = ''"
            style="cursor: pointer;"></i>
        </div>
        <button class="btn btn-primary" (click)="openCreateModal()">
          {{ 'roles-page.new-role' | translate }}
        </button>
      </div>
    </div>


    <!-- Roles table -->
    <div class="luqta-card" *ngIf="!isLoading">
      <div class="card-heading">
        <h3>{{ 'roles-page.all-roles' | translate }} ({{ roles.length }})</h3>
      </div>

      <nz-table #rolesTable [nzData]="filteredRoles" [nzBordered]="false" [nzFrontPagination]="false"
        [nzShowPagination]="false" [nzNoResult]="noRolesTpl">
        <thead>
          <tr>
            <th nzWidth="260px" class="ps-4">{{ 'roles-page.col-role' | translate }}</th>
            <th class="text-center">{{ 'roles-page.col-description' | translate }}</th>
            <th nzWidth="160px" class="text-center">{{ 'roles-page.col-pages-allowed' | translate }}</th>
            <th nzWidth="160px" class="text-center">{{ 'roles-page.col-sub-users' | translate }}</th>
            <th nzWidth="260px" class="text-end pe-4">{{ 'roles-page.col-actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let role of rolesTable.data">
            <!-- Role -->
            <td class="ps-4">
              <div class="d-flex align-items-center gap-3">
                <div class="role-avatar" [style.background]="role.color + '15'" [style.color]="role.color">
                  <i [class]="role.icon || 'fa-solid fa-shield-halved'"></i>
                </div>
                <div>
                  <h5 class="role-name mb-0">{{ role.policy_name }}</h5>
                  <span class="role-badge badge-custom">ID: #{{ role.id }}</span>
                </div>
              </div>
            </td>

            <!-- Description -->
            <td class="text-center">
              <p class="role-desc mb-0">
                {{ role.description || ('roles-page.default-role-desc' | translate) }}
              </p>
            </td>

            <!-- Pages this role can open -->
            <td class="text-center">
              <span class="pages-pill" [class.none]="!role.grantedPages">
                <i class="fa-solid fa-file-lines"></i>
                <strong>{{ role.grantedPages || 0 }}</strong>
                <span class="of-total" *ngIf="role.totalPages">/ {{ role.totalPages }}</span>
              </span>
            </td>

            <!-- Assigned sub-users -->
            <td class="text-center">
              <span class="sub-user-pill">
                <i class="fa-solid fa-users"></i>
                <strong>{{ role.memberCount || 0 }}</strong>
                {{ (role.memberCount === 1 ? 'roles-page.sub-user' : 'roles-page.sub-users') | translate }}
              </span>
            </td>

            <!-- Actions -->
            <td class="text-end pe-4">
              <div class="d-flex align-items-center justify-content-end gap-2">
                <button class="btn btn-primary btn-configure" (click)="navigateToManage(role.id, 'permissions')">
                  <i class="fa-solid fa-sliders" style="margin-inline-end: 6px;"></i>
                  {{ 'roles-page.configure' | translate }}
                </button>
                <button class="btn-icon-action" (click)="navigateToManage(role.id, 'users')"
                  [title]="'roles-page.assign-users-tooltip' | translate">
                  <i class="fa-solid fa-user-plus"></i>
                </button>
                <button class="btn-icon-action" (click)="openEditModal(role, $event)"
                  [title]="'roles-page.edit-role' | translate">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button class="btn-icon-action btn-icon-danger" (click)="openDeleteModal(role, $event)"
                  [title]="'roles-page.delete-role' | translate">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <!-- Empty state, kept so the create action stays reachable -->
      <ng-template #noRolesTpl>
        <div class="text-center py-5">
          <i class="fa-solid fa-shield-halved text-muted mb-3 d-block" style="font-size: 42px;"></i>
          <h5 class="font-weight-600">{{ 'roles-page.empty-title' | translate }}</h5>
          <p class="text-muted small mb-4">
            {{ (searchTerm ? 'roles-page.empty-search' : 'roles-page.empty-desc') | translate }}
          </p>
          <button class="btn btn-primary" *ngIf="!searchTerm" (click)="openCreateModal()">
            {{ 'roles-page.create-first' | translate }}
          </button>
        </div>
      </ng-template>
    </div>

  <!-- Create Role Modal -->
  <nz-modal nzClassName="luqta-custom-modal" [nzCentered]="true" [(nzVisible)]="isCreateModalVisible"
    [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter" (nzOnCancel)="closeCreateModal()"
    [nzWidth]="540">
    <ng-template #modalTitle>
      <div class="d-flex align-items-center gap-2">
        <div class="modal-role-icon"
          style="background: rgba(255, 255, 255, 0.2); color: #FFFFFF; width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fa-solid fa-plus"></i>
        </div>
        <span style="font-family: 'Codec Pro'; font-weight: 600; font-size: 17px; color: #FFFFFF;">
          {{ 'roles-page.create-role-title' | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template #modalContent>
      <div class="create-role-form py-3 px-1">
        <!-- Policy Name -->
        <div class="mb-4">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-name' | translate }} <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" [(ngModel)]="newRoleName" (input)="onRoleNameInput()"
            [placeholder]="'roles-page.role-name-placeholder' | translate"
            style="height: 48px; border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding-left: 16px;"
            [class.is-invalid]="!!inlineNameError" />
          <!-- Inline Error for duplicate name -->
          <div *ngIf="inlineNameError" class="text-danger mt-1.5 small d-flex align-items-center gap-1">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ inlineNameError }}</span>
          </div>
          <small class="text-muted d-flex align-items-center gap-1 mt-1.5" style="font-size: 12px;">
            <i class="fa-solid fa-circle-info" style="color: #5304FB;"></i>
            {{ 'roles-page.role-name-hint' | translate }}
          </small>
        </div>

        <!-- Description -->
        <div class="mb-2">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-desc' | translate }}
          </label>
          <textarea class="form-control" rows="3" [(ngModel)]="newRoleDescription"
            [placeholder]="'roles-page.role-desc-placeholder' | translate"
            style="border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding: 12px 16px;"></textarea>
        </div>
      </div>
    </ng-template>

    <ng-template #modalFooter>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-light"
          style="border-radius: 12px; height: 46px; padding: 0 22px; font-size: 14px; font-weight: 500; border: 1.5px solid rgba(0, 0, 0, 0.1); background: #FFFFFF; color: #344054;"
          (click)="closeCreateModal()" [disabled]="isSaving">
          {{ 'roles-page.cancel' | translate }}
        </button>
        <button class="btn btn-primary"
          style="border-radius: 12px; height: 46px; padding: 0 24px; font-size: 14px; font-weight: 500; font-family: 'Codec Pro', sans-serif; background: linear-gradient(62.82deg, #8F67FD -31.84%, #5304FB 80.32%); border: none; color: #FFFFFF; box-shadow: 0 4px 14px rgba(83, 4, 251, 0.28);"
          (click)="handleCreateRole()" [disabled]="isSaving || !newRoleName.trim()">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSaving" class="fa-solid fa-plus me-2"></i>
          {{ isSaving ? ('roles-page.creating' | translate) : ('roles-page.create-role' | translate) }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

  <!-- Edit Role Modal -->
  <nz-modal nzClassName="luqta-custom-modal" [nzCentered]="true" [(nzVisible)]="isEditModalVisible"
    [nzTitle]="editModalTitle" [nzContent]="editModalContent" [nzFooter]="editModalFooter"
    (nzOnCancel)="closeEditModal()" [nzWidth]="540">
    <ng-template #editModalTitle>
      <div class="d-flex align-items-center gap-2">
        <div class="modal-role-icon"
          style="background: rgba(255, 255, 255, 0.2); color: #FFFFFF; width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fa-solid fa-pen-to-square"></i>
        </div>
        <span style="font-family: 'Codec Pro'; font-weight: 600; font-size: 17px; color: #FFFFFF;">
          {{ 'roles-page.edit-role-title' | translate }} #{{ editingRole?.id }}
        </span>
      </div>
    </ng-template>

    <ng-template #editModalContent>
      <div class="create-role-form py-3 px-1">
        <!-- Role Name -->
        <div class="mb-4">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-name' | translate }} <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" [(ngModel)]="editRoleName" (input)="onEditRoleNameInput()"
            [placeholder]="'roles-page.role-name-placeholder' | translate"
            style="height: 48px; border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding-left: 16px;"
            [class.is-invalid]="!!inlineEditNameError" />
          <div *ngIf="inlineEditNameError" class="text-danger mt-1.5 small d-flex align-items-center gap-1">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ inlineEditNameError }}</span>
          </div>
        </div>

        <!-- Description -->
        <div class="mb-2">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-desc' | translate }}
          </label>
          <textarea class="form-control" rows="3" [(ngModel)]="editRoleDescription"
            [placeholder]="'roles-page.role-desc-placeholder' | translate"
            style="border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding: 12px 16px;"></textarea>
        </div>
      </div>
    </ng-template>

    <ng-template #editModalFooter>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-light"
          style="border-radius: 12px; height: 46px; padding: 0 22px; font-size: 14px; font-weight: 500; border: 1.5px solid rgba(0, 0, 0, 0.1); background: #FFFFFF; color: #344054;"
          (click)="closeEditModal()" [disabled]="isUpdating">
          {{ 'roles-page.cancel' | translate }}
        </button>
        <button class="btn btn-primary"
          style="border-radius: 12px; height: 46px; padding: 0 24px; font-size: 14px; font-weight: 500; font-family: 'Codec Pro', sans-serif; background: linear-gradient(62.82deg, #8F67FD -31.84%, #5304FB 80.32%); border: none; color: #FFFFFF; box-shadow: 0 4px 14px rgba(83, 4, 251, 0.28);"
          (click)="handleUpdateRole()" [disabled]="isUpdating || !editRoleName.trim()">
          <span *ngIf="isUpdating" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isUpdating" class="fa-solid fa-check me-2"></i>
          {{ isUpdating ? ('roles-page.saving' | translate) : ('roles-page.save-changes' | translate) }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

  <!-- Delete Role Confirmation Modal -->
  <nz-modal
    [(nzVisible)]="isDeleteModalVisible"
    [nzCentered]="true"
    [nzFooter]="null"
    (nzOnCancel)="closeDeleteModal()"
    nzClassName="pricing-modal"
  >
    <ng-container *nzModalContent>
      <div class="downgrade-modal">
        <h5>{{ 'roles-page.delete-role-title' | translate }}</h5>
        <p>
          {{ 'roles-page.delete-confirm-question' | translate:{ name: getRoleDisplayName(deletingRole), id: deletingRole?.id } }}
        </p>

        <div *ngIf="(deletingRole?.memberCount || 0) > 0"
          class="alert alert-warning d-flex align-items-start gap-2 p-3 mt-3 mb-4"
          style="border-radius: 10px; background: #FFFBEB; border: 1px solid #FDE68A; color: #B45309; font-size: 13px;">
          <i class="fa-solid fa-triangle-exclamation mt-0.5"></i>
          <div>
            {{ 'roles-page.delete-warning' | translate:{ count: deletingRole?.memberCount } }}
          </div>
        </div>
        <div class="bottom-btns">
          <button class="btn btn-cancel" (click)="closeDeleteModal()" [disabled]="isDeleting">
            {{ 'roles-page.cancel' | translate }}
          </button>
          <button class="btn btn-downgrade" (click)="handleDeleteRole()" [disabled]="isDeleting">
            <span *ngIf="isDeleting" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isDeleting" class="fa-solid fa-trash-can me-2"></i>
            {{ isDeleting ? ('roles-page.saving' | translate) : ('roles-page.delete-role' | translate) }}
          </button>
        </div>
      </div>
    </ng-container>
  </nz-modal>

</div>